const MARQUEE_ITEMS = [
  'BULLION EMBLEM',
  'HANDMADE EMBROIDERY',
  'PREMIUM QUALITY',
  'MASTER CRAFTSMANSHIP',
  'CUSTOM ORDERS',
  'SINCE 1987',
  'HIVAN TEX',
];

export default function MarqueeStrip() {
  const doubled = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];

  return (
    <div className="bg-gold py-3 overflow-hidden">
      <div className="flex animate-marquee whitespace-nowrap">
        {doubled.map((item, i) => (
          <span
            key={i}
            className="inline-flex items-center mx-7 text-charcoal text-[10px] tracking-[0.22em] uppercase font-sans"
          >
            {item}
            <span className="ml-7 text-charcoal/40">·</span>
          </span>
        ))}
      </div>
    </div>
  );
}
